import {AppState} from '../states/app.state';
import {createSelector} from '@ngrx/store';
import {identity} from 'rxjs';
import {landEntitiesAdapter} from '../adapters/land-entities.adapters';


export class LandEntitiesSelectors {

  private static adapterSelectors = landEntitiesAdapter.getSelectors();

  private static select = {
    entities: (state: AppState) => state.landEntities,
    isLoaded: (state: AppState) => state.landEntities.laenderLoaded,
    filter: (state: AppState) => state.landEntities.filter,
  };

  public static all = createSelector(
    this.select.entities,
    this.adapterSelectors.selectAll,
  );

  public static laenderLoaded = createSelector(
    this.select.isLoaded,
    identity,
  );

  public static filter = createSelector(
    this.select.filter,
    identity,
  );

  public static landByBetriebAndIsoAlpha2 = (betriebId: string, isoAlpha2: string) => createSelector(
    this.all,
    laender => laender.find(land => {
      return land.betriebId === betriebId && land.isoAlpha2 === isoAlpha2;
    }),
  );

  public static laenderByBetrieb = (betriebId: string) => createSelector(
    this.all,
    laender => laender.filter(land => {
      return land.betriebId === betriebId;
    }),
  );

  public static filteredLaenderByBetrieb = (betriebId: string) => createSelector(
    this.laenderByBetrieb(betriebId),
    this.filter,
    (laender, filter) => {
      const needle = (filter || '').toLowerCase();
      if (!needle) return laender;
      return laender.filter(land => {
        const bezMatch = !!land.bezeichnung && land.bezeichnung.toLowerCase().includes(needle);
        const isoMatch = !!land.isoAlpha2 && land.isoAlpha2.toLowerCase().includes(needle);
        return bezMatch || isoMatch;
      });
    },
  );

}
